import { render, staticRenderFns } from "./ConcernSummary.vue?vue&type=template&id=467d3d4c"
import script from "./ConcernSummary.vue?vue&type=script&lang=js"
export * from "./ConcernSummary.vue?vue&type=script&lang=js"
import style0 from "./ConcernSummary.vue?vue&type=style&index=0&id=467d3d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports